// extracted by mini-css-extract-plugin
module.exports = {"specs":"specs_specs__GQPuQ"};